import { Box, Typography } from "@drone-js/core";
import { ImportedSection } from "./ImportedSection";
import { ListingControls } from "./ListingControls";
import { ListingSection } from "./ListingSection";
import { Loader } from "./Loader";
import { NotificationEmptySelectedProperty } from "./NotificationEmptySelectedProperty";
import { useAutomaticListsHandler } from "./useAutomaticListsHandler";
import { useScrapeProperties } from "./useScrapeProperties";

import "./overrides.css";
import { automaticListsBinder } from "libs/analytics/binders/propertySelection/automaticLists";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { Footer } from "../Footer";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { ValidationErrorNotification } from "../urlInput/ValidationErrorNotification.tsx";
import { scrapingErrorResponseMapper } from "../urlInput/scrapingErrorResponseMapper.ts";
import { useURLInputValue } from "../urlInput/urlInputAtom";

export const AutomaticListsPage = () => {
    const {
        automaticPropertySelectionCms: { pageTitle },
    } = usePropertySelectionViewModelValue();

    // url will be received from input atom at input page, but input page does not exist at the moment
    const inputUrl = useURLInputValue();
    const { loading } = useScrapeProperties(inputUrl);

    const { error, ...footerProps } = useAutomaticListsHandler();
    useAnalytics(automaticListsBinder);

    if (loading) return <Loader />;

    return (
        <Box pb="32" display="flex" flexDirection="column">
            <Box
                backgroundColor="base.surface"
                pt="32"
                pb="8"
                px="16"
                mx="-16"
                mb="8"
                position="sticky"
                // navbar height + top padding
                top={0}
                zIndex={999}
            >
                <Box qM={{ display: "flex", justifyContent: "space-between", alignItems: "end" }}>
                    <Typography variant="heading-xl" textColor="base.default">
                        {pageTitle}
                    </Typography>
                    <ListingControls />
                </Box>
                {error === scrapingErrorResponseMapper.EmptyInput && <NotificationEmptySelectedProperty />}
            </Box>
            <ListingSection />
            <ImportedSection />
            <Footer {...footerProps} />
            <ValidationErrorNotification errorType={error} errorMessage="" />
        </Box>
    );
};
